import React from "react";

import { OrdersList } from "components/Orders/OrdersList";

const OrdersListPage = () => {
  return <OrdersList />;
};
export default OrdersListPage;
